import { Business, Location, Search } from "@boxicons/react"

export function EaboutABP() {
    return (
        <section className="dropdowns-box">
            <div className="dropdown">
                <div className="tittle-icon-box">
                    <h3>The company</h3>
                    <i class='bx bx-chevron-up'></i>
                </div>
                <div className="information-box">
                    <Business pack="filled" className="i-about" size="xl"/>
                    <p>
                        <br></br>
                        With over 5 years<br></br>
                        of experience in the industry,<br></br>
                        we have been delivering<br></br>
                        expert services<br></br>
                        since May 2021.
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </p>
                </div>
            </div>
            <div className="dropdown">
                <div className="tittle-icon-box">
                    <h3>Mission</h3>
                    <i class='bx bx-chevron-up'></i>
                </div>
                <div className="information-box">
                    <Search size="xl"  className="i-about"/>
                    <p>
                        <br></br>
                        Positioning in<br />
                        specialized sectors<br />
                        for<br />
                        micro, small, and<br />
                        medium-sized enterprises
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </p>
                </div>
            </div>
            <div className="dropdown">
                <div className="tittle-icon-box">
                    <h3>Location</h3>
                    <i class='bx bx-chevron-up'></i>
                </div>
                <div className="information-box">
                    <Location pack="filled" size="xl" className="i-about"/>
                    <p>
                        <br></br>
                        Office D, Interior A, 4th Floor<br></br>
                        Exterior Number: 5060<br></br>
                        López Mateos Sur Avenue<br></br>
                        Miguel de la Madrid Hurtado Neighborhood<br></br>
                        Zapopan, Jalisco, México
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </p>
                </div>
            </div>
        </section>
    )
}